// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { cache, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  eye_view,
  Search_icon,
  view_icon,
} from "../../../assets/img";
import Topbar from "../../../components/Topbar/Topbar";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import moment from "moment";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import DateRange from "../../../components/DateRange/DateRange";
import { checkPermission } from "../../redux/api/PermissionManager";
import { Toast } from "bootstrap";
import UnReadNotificationPopup from "../../../components/UnReadNotificationPopup";

const OwnerList = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [popup, setPopup] = useState(false);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");
  const [pagination, setPagination] = useState({});
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [owners, setOwners] = useState([]);
  const [OwnersCount, setOwnersCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    unread_only: false,
  });
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");
  const handleChangeFilter = (name, val) => {
    let { from, to } = selectedFilter;
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  console.log("console", page);
  // console.log("from to date", selectedFilter.from, selectedFilter.to);
  useEffect(() => {
    getList();
    // to store the pagination data into context
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: search },
    }));
  }, [page, search, selectedFilter?.unread_only]);

  useEffect(() => {
    const { from, to, unread_only } = selectedFilter;
    if ((from && to) || (!from && !to) || unread_only) getList();
  }, [selectedFilter.from, selectedFilter.to, selectedFilter?.unread_only]);

  const getList = async () => {
    const { from, to, unread_only } = selectedFilter;
    let urlParams = `${search && "&search=" + search} &unread_only=${unread_only}${
      from && to ? `&from_date=${from}&to_date=${to}` : ""
    }`;

    const res = await get(`${URLS.OWNERS}?page=${page}${urlParams} `);
    if (res?.status === "success") {
      console.log("owner response success", res);
      setPagination({
        current_page: page,
        last_page: res?.next ? page + 1 : page,
      });
      setOwnersCount(res?.count);
      setOwners(res?.data);
    }
  };

  const handleStatus = async (id, status) => {
    if (!checkPermission("CAN-STATUS-OWNER")) return;
    console.log("id", id);
    const res = await post(URLS.OWNERS + id + "/status/", { status: status });
    console.log("delete owner res", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };
  const handleDelete = async (id) => {
    const res = await post(URLS.OWNERS + id + "/delete/");
    console.log("delete owner res", res);
    if (res?.status === "success") {
      setPopup(false);
      toast.success(res?.message);
      getList();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
              {row?.original?.has_unread_notification && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                  style={{ width: 20, height: 20, marginTop: 9 }}
                />
              )}
              {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )}
            </div>
          );
        },
      },
      // {
      //   Header: " Owner ID",
      //   accessor: "id",
      //   Cell: ({ value, row }) => {
      //     return <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>;
      //   },
      // },
      {
        Header: "Registered date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: "Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="text-nowrap">
              <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
              <p style={{ color: "#AE55F5", fontWeight: "600" }}>
                {row.original.code}
              </p>
            </div>
          );
        },
      },
      {
        Header: " Email ID",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Total Property Count",
        accessor: "property_count",
        Cell: ({ value, row }) => {
          return <p className="text-center">{value ?? "-"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original.id, value === 1 ? 2 : 1);
                }}
                className={`${
                  value === 1 ? "active-btn" : "deactive-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
              >
                {value === 1 ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-VIEW-OWNER") && (
                  <button
                    onClick={() => {
                      navigate("/add-owner", {
                        state: { type: "view", id: row.original.id },
                      });
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-EDIT-OWNER") && (
                  <button
                    onClick={() => {
                      navigate("/add-owner", {
                        state: {
                          type: "edit",
                          id: row.original.id,
                        },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-DELETE-OWNER") && (
                  <button
                    onClick={() => {
                      setPopup(row.original.id);
                    }}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page, selectedOwners],
  );

  console.log("isViewDetails", isViewDetails);

  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
    const res = console.log("Selected Owners:", payload);
  };
  return (
    <div>
      <Topbar header={"User List"} subHead={"Owner"} />
      <div
        className="d-flex "
        style={{
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <div
          className="d-flex mb-4"
          style={{
            flexDirection: "row",
            // justifyContent: "space-between",
            width: "100%",
            gap: 10,
          }}
        >
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
            Total:{OwnersCount}
          </h2>
          <div className="d-flex" style={{ alignItems: "center" }}>
            <input
              type="checkbox"
              checked={selectedFilter?.unread_only}
              onChange={() =>
                handleChangeFilter("unread_only", !selectedFilter?.unread_only)
              }
            />{" "}
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
              Check New Notification
            </p>
            {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
          </div>
        </div>

        <div
          className="d-flex gap-3"
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#6B00D8",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 9,
              fontSize: "16px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Owner List
          </div>
          <div
            className="d-flex gap-3"
            style={{
              // justifyContent: "space-between",
              // width: "100%",
              alignItems: "center",
            }}
          >
            <DateRange
              setFromDate={(date) => {
                handleChangeFilter("from", date);
              }}
              setToDate={(date) => {
                handleChangeFilter("to", date);
              }}
            />
            <div className="search-input">
              <input
                //  onChange={(e) => (OwnerList(1, e.target.value))}
                type="text"
                placeholder="Search"
                style={{ border: "none", width: "150px" }}
                onChange={(e) => {
                  setPage(1);
                  setSearch(e.target.value);
                }}
                value={search}
              />
              <img alt="" src={Search_icon} className="search" />
            </div>
            {checkPermission("CAN-ADD-OWNER") && (
              <button 
               onClick={() => navigate("/add-owner")}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn ">
                {" "}
                + Add Owner
              </button>
            )}
          </div>
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(popup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
      {showSubmitPopup && (
        <div className="img-popup-design">
          <div
            className="img-popup"
            style={{ height: "auto", padding: "20px" }}
          >
            <h3 className="f2 mb-3">Submit Description</h3>
            <textarea
              // className="form-control mb-3"
              rows="4"
              placeholder="Enter description here..."
              value={submissionDescription}
              onChange={(e) => setSubmissionDescription(e.target.value)}
              style={{ width: "100%", borderRadius: "8px", padding: "10px" }}
            ></textarea>
            <div className="d-flex ac-jb gap-3">
              <button onClick={handleSumbit} className="add-btn w-50">
                Submit
              </button>
              <button
                onClick={() => {
                  setShowSubmitPopup(false);
                  setSubmissionDescription("");
                }}
                className="back-btn f2 w-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default OwnerList;
